export function formatTime(date) {
    var d = new Date(date);
    var time = d.toLocaleTimeString('en-US', { timeZone: 'Asia/Muscat', hour12: true, hour: 'numeric', minute: 'numeric' });

    var dateString = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + " " + time;

    return dateString;
  }


  export function getRemainingTimeFor7Days(date) {
    if(!date){
        return "";
    }
    const now = new Date();
    const startDate = new Date(date);
    
    // Add 7 days to the start date
    const endDate = new Date(startDate.getTime() + 7 * 24 * 60 * 60 * 1000);

    // Calculate the difference in milliseconds
    const diffMs = endDate - now;

        // If 7 days have already passed
        if (diffMs <= 0) {
            return "Expired";
        }

    // Convert the difference to days, hours, minutes, and seconds
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    // Format the remaining time
    const remainingTime = `${diffDays} days, ${diffHours}:${diffMinutes}:${diffSeconds}`;

    return remainingTime;
}

export function getPaymentLinkExpirationStatus(payment_link_expire_at, payment_link) {
    if (!payment_link) {
        return { isExpired: false, remainingTime: "", status: "no_link" };
    }

    // No expiration date = unlimited (e.g. paymob)
    if (!payment_link_expire_at) {
        return { isExpired: false, remainingTime: "Unlimited", status: "unlimited" };
    }

    const now = new Date();
    const expireDate = new Date(payment_link_expire_at);
    const diffMs = expireDate - now;

    if (diffMs <= 0) {
        return { isExpired: true, remainingTime: "Expired", status: "expired" };
    }

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const diffSeconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    const remainingTime = `${diffDays} days, ${diffHours}:${String(diffMinutes).padStart(2, '0')}:${String(diffSeconds).padStart(2, '0')}`;
    return { isExpired: false, remainingTime, status: "active" };
}
